import { canDownloadKYC } from 'src/functions/fileManagerMethods';
import { MenuDownloadProps } from 'src/models/emission/EmissionDocument';

export type FileDownloadItem = {
  quotationHash: string;
  fileName: string;
};

const createFileDownloadItem = (
  quotationHash: string,
  fileName: string,
): FileDownloadItem => ({ fileName, quotationHash });

export function createFileList({
  createdAt,
  hasIdentityDocument,
  hasOptionalIdentityDocument,
  inspectionRequired,
  quotationHash,
}: MenuDownloadProps): FileDownloadItem[] {
  const downloadingKyc = canDownloadKYC(createdAt);
  const documentList: FileDownloadItem[] = downloadingKyc
    ? [createFileDownloadItem(quotationHash, 'policy')]
    : [];
  if (hasIdentityDocument) {
    documentList.push(createFileDownloadItem(quotationHash, 'cedula'));
  }
  if (hasOptionalIdentityDocument) {
    documentList.push(createFileDownloadItem(quotationHash, 'cedula-optional'));
  }
  documentList.push(
    createFileDownloadItem(
      quotationHash,
      inspectionRequired ? 'inspectionReport' : 'proforma',
    ),
  );
  documentList.push(createFileDownloadItem(quotationHash, 'quotation'));
  return documentList;
}

export function createEmptyFileList(): FileDownloadItem[] {
  return [];
}
